import { urls } from "../urls";
import { useToastAlert } from "../common/alerts/useToastAlert";
import { useAudit } from "../hooks/useAudit";
import { useTableStore } from "state";
import { useEffect } from "react";

export const useAgencyManagement = () => {
    const url = urls.AGENCY
    const { addAuditEvent } = useAudit();
    const { notifySuccess, notifyError } = useToastAlert();
    const currentPageName = useTableStore(state => state.pageName)
    const agencyUrl = `${process.env.NODE_ENV === 'production' ? url : ""}/agency`

    useEffect(() => {
        if (currentPageName !== 'agency-management') {
            console.log(`useAgencyManagement: not on agency-management page, skipping query`)
            return
        }
    }, [currentPageName])


    const createAgency = async (agencyId: string, agency: any) => {
        const body = {
            id: agencyId,
            isActive: true,
            json_data: agency,
        }

        try {
            const resp = await fetch(`${agencyUrl}/${agencyId}`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(body),
            });

            const error = await resp.text();

            if (resp?.ok) {
                notifySuccess('Success', 'A new agency was successfully created!')
                addAuditEvent("Added Agency", `Added data: ${JSON.stringify(agency)}`, new Date(), agencyId);
            } else {
                notifyError('Agency Creation Error', error)
            }

            return resp
        } catch (err) {
            console.log('Creating Agency Error: ', err);
        }
    }


    const updateAgency = async (agencyId: string, agency: any) => {
        const body = {
            id: agencyId,
            isActive: true,
            json_data: agency,
        }

        try {
            const resp = await fetch(`${agencyUrl}/${agencyId}`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(body)
            })

            if (resp.ok) {
                notifySuccess('Success', 'Agency record was successfully updated.')
                addAuditEvent("Updated Agency", `Updated data: ${JSON.stringify(agency)}`, new Date(), agencyId);
            } else throw new Error(`HTTP error: ${resp.status}`)

            return resp
        } catch (err) {
            console.log('Creating Agency Error: ', err);
            notifyError('Agency Update Error', 'Please contact your administrator')
        }
    }

    const deleteAgency = async (agencyId) => {
        const endpoint = `${process.env.NODE_ENV === 'production' ? url : ""}/agency/${agencyId}`;

        const options: RequestInit = {
            method: "DELETE",
            credentials: "include",
        };

        try {
            const response = await (await fetch(endpoint, options)).json();
            return response;
        } catch (error: any) {
            console.error(error);
            throw error;
        }
    }

    return { createAgency, updateAgency, deleteAgency }
}
